<template>
	<NuxtLayout>
		<NuxtLoadingIndicator color="var(--cta-color)" />
		<NuxtPage />
	</NuxtLayout>
</template>
